import { BookmarkObject } from "./types";

export const bookmarkCacheUpdate = ({ relatedId, relatedObjectType }: BookmarkObject, action: "ADD" | "REMOVE") => {
  const keyMap = { CLAUSE: "clauses", DOCUMENT: "documents", COMMENT: "comments" };
  const objectKey = keyMap[relatedObjectType] as "clauses" | "documents" | "comments";

  return (savedData: any) => {
    if (action === "ADD") {
      savedData[objectKey].push(relatedId);
    } else if (action === "REMOVE") {
      const idx = savedData[objectKey].indexOf(relatedId);
      if (idx !== -1) {
        savedData[objectKey].splice(idx, 1);
      }
    }
  };
};
